<!--
  - This file is part of the Web3 Library developed by mFactory GmbH.
  -
  - Copyright © 2021, mFactory GmbH
  -
  - Solana Reference Stake Pool is free software: you can redistribute it
  - and/or modify it under the terms of the GNU Affero General Public License
  - as published by the Free Software Foundation, either version 3
  - of the License, or (at your option) any later version.
  -
  - Solana Reference Stake Pool is distributed in the hope that it
  - will be useful, but WITHOUT ANY WARRANTY; without even the implied
  - warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
  - See the GNU Affero General Public License for more details.
  -
  - You should have received a copy of the GNU Affero General Public License
  - along with this program.
  - If not, see <https://www.gnu.org/licenses/agpl-3.0.html>.
  -
  - You can be released from the requirements of the Affero GNU General Public License
  - by purchasing a commercial license. The purchase of such a license is
  - mandatory as soon as you develop commercial activities using the
  - Solana Reference Stake Pool code without disclosing the source code of
  - your own applications.
  -
  - The developer of this program can be contacted at <info@mfactory.ch>.
  -->

<script setup lang="ts">
import { computed } from 'vue'

const stakeAccountStore = useStakeAccountStore()
const stakesOnServer = computed(() => stakeAccountStore.stakesOnServer)
const hasAllData = computed(() => stakeAccountStore.hasAllData)
const stateLoaded = computed(() => stakeAccountStore.stateLoaded)
</script>

<template>
  <div v-if="stateLoaded && (!stakesOnServer || (stakesOnServer && !hasAllData))">
    <span class="text-negative">* </span>
    <span v-if="!stakesOnServer" :style="{ fontSize: '12px' }">
      Only rewards from several last epochs are shown. Click RETRIEVE ALL to see total rewards
      accrued for this staking account.
    </span>
    <span v-if="stakesOnServer && !hasAllData" :style="{ fontSize: '12px' }">
      Retrieve all data in progress. This may take some time.
    </span>
  </div>
</template>
